export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-parametrizacao' */ '@/views/ambulatorio/parametrizacao/Index'),
        path: 'parametrizacao',
        redirect: 'parametrizacao/create',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-parametrizacao' */ '@/views/ambulatorio/parametrizacao/Form.vue'),
                name: 'ambulatorio-parametrizacao-create',
                path: 'create',
            },
        ],
    },
]